import { proxy } from "valtio";

export const selectedViewLayout = proxy<{ value: "table" | "tree" }>({
	value: "tree",
});
